export enum CartoesEnum {
  GOLDPADRAO = 'GOLD',
  GOLD_DIGITAL = 'GOLD_DIGITAL',
  ATHLETICO = 'ATHLETICO',
  ATHLETICO_DIGITAL = 'ATHLETICO_DIGITAL',
  LAION = 'FORTALEZA',
  LAION_DIGITAL = 'FORTALEZA_DIGITAL',
}
